module.exports = __webpack_public_path__ + "static/media/fly0194.93abab6a.webp";